
// export const myGetter = ( subsidiary ) => {
//  return subsidiary
// }

export const subsidiariesList = state => state.subsidiaries
export const subsidiariesSelectable = state => state.subsidiariesSelectable
export const subsidiariesPaginatedData = state => state.subsidiariesPaginatedData
export const subsidiary = state => state.subsidiary
export const subsidiarySelect = state => state.subsidiarySelect
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData